import { FC } from 'react';
import { Typography, Paper, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import makeStyles from '@mui/styles/makeStyles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import orderState, { entitiesState, filesState } from 'TaxAnalyticsState/orderState';
import { useRecoilValue } from 'recoil';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    ellipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
}));

export const OrderSummary: FC = (props: any) => {
    const classes = useStyles();
    const order = useRecoilValue(orderState);
    const files = useRecoilValue(filesState);
    const entities = useRecoilValue(entitiesState);
    return (
        <Paper elevation={0}>
            <Grid container alignItems="center" justifyContent="center">
                <Grid md={6} xs={12}>
                    <Typography variant="h4">Récapitulatif de votre commande</Typography>
                </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
                <Grid md={6} xs={12}>
                    <List className={classes.root}>
                        <ListItem alignItems="flex-start" style={{ display: "block" }}>
                            <Box marginBottom={2} className={classes.ellipsis}>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                    component="p"
                                    fontWeight="bold"
                                >
                                    Référence
                                </Typography>
                            </Box>
                            <Box marginBottom={1} className={classes.ellipsis}>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    color="textPrimary"
                                >
                                    {order?.tajReference}
                                </Typography>
                            </Box>
                        </ListItem>
                        <Divider variant="fullWidth" component="li" />
                        <ListItem alignItems="flex-start" style={{ display: "block" }}>
                            <Box marginBottom={2} className={classes.ellipsis}>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                    component="p"
                                    fontWeight="bold"
                                >
                                    Date de création
                                </Typography>
                            </Box>
                            <Box marginBottom={1} className={classes.ellipsis}>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    color="textPrimary"
                                >
                                    {new Date((order?.creationDate ?? "") as string).toLocaleString('fr-FR')}
                                </Typography>
                            </Box>
                        </ListItem>
                        <Divider variant="fullWidth" component="li" />
                        <ListItem alignItems="flex-start" style={{ display: "block" }}>
                            <Box marginBottom={2} className={classes.ellipsis}>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                    component="p"
                                    fontWeight="bold"
                                >
                                    Entité
                                </Typography>
                            </Box>
                            <Box marginBottom={1} className={classes.ellipsis}>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    color="textPrimary"
                                >
                                    {entities?.find(e => e.id === order?.entityId)?.name}
                                </Typography>
                            </Box>
                        </ListItem>
                        <Divider variant="fullWidth" component="li" />
                        <ListItem alignItems="flex-start" style={{ display: "block" }}>
                            <Box marginBottom={2} className={classes.ellipsis}>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                    component="p"
                                    fontWeight="bold"
                                >
                                    Informations saisies
                                </Typography>
                            </Box>
                            {order?.orderInputSettings?.map((setting, index) => {
                                if (setting)
                                    return (
                                        <Box key={index} marginBottom={1} className={classes.ellipsis}>
                                            <Typography
                                                variant="body2"
                                                color="textPrimary"
                                                fontWeight="bold"
                                                component="span"
                                                sx={{marginRight:2} }
                                            >
                                                {setting?.setting?.translations![0].description} :
                                            </Typography>
                                            {setting.value} {'\u00A0'}
                                        </Box>
                                    )
                            }
                            )}
                        </ListItem>
                        <Divider variant="fullWidth" component="li" />
                        <ListItem alignItems="flex-start" style={{ display: "block" }}>
                            <Box marginBottom={2}>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                    component="p"
                                    fontWeight="bold"
                                >
                                    Fichiers
                                </Typography>
                            </Box>
                            {files?.map((file, index) =>
                                <Box marginBottom={1} key={index}>
                                    <Typography
                                        variant="body2"
                                        color="textPrimary"
                                    >
                                        {file.name}
                                    </Typography>
                                </Box>
                            )}
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </Paper>
    );
}